import React from "react"
import { Link } from "gatsby"
import Header from "../../layouts/header4"
import Footer from "../../layouts/footer4"
import FloatingBtn from "../../components/custom-components/floatingBtn"
import Seo from "../../components/seo"

import bg from "../../images/banner/Banner1.png"

const QualityPolicy = () => {
  return (
    <div className="skin-1 index">
      <Seo title="Quality Policy" />
      <Header policyPage />
      <FloatingBtn />

      {/* Header */}
      <div className="page-content bg-white">
        <div
          className="dlab-bnr-inr header-contact overlay-black-middle bg-pt"
          style={{ backgroundImage: "url(" + bg + ")", objectFit:"cover" }}
        >
          <div className="hero-content">
            <div className="container">
              <div className="dlab-bnr-inr-entry">
                <div className="d-flex flex-column text-left entry-contact">
                  <h1 className="text-white">Quality Policy</h1>
                </div>
                <div className="breadcrumb-row entry-contact">
                  <ul className="list-inline entry-contact">
                    <li>
                      <Link to="/">Home</Link>
                    </li>
                    <li>Quality Policy</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="section-full content-inner bg-white contact-style-1">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h2 className="m-b20">QUALITY POLICY</h2>
              <p>PT. KalGen DNA is committed to deliver high quality diagnostic products and services by adopting Cara Produksi Alat Kesehatan yang Baik (CPAKB), ISO 13485 and related Standards for Medical Devices.</p>
              <p>We are committed to continually improve the Quality Management System without affecting the intended purpose of our products and provide an effective management system framework for monitoring the quality objective(s) that being set from time to time to attain the best result of our Quality Management System and fulfilling the applicable regulatory and other requirements.</p>
            </div>
          </div>
        </div>
      </div>
      <Footer hideContactInfo />
    </div>
  )
}

export default QualityPolicy
